import React, { Component } from "react";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import FileUploadResourceTypeEnum from "../../../../models/FileUploadResourceTypeEnum";
import IAttachment from "../../../../models/IAttachment";
import ICatalog from "../../../../models/ICatalog";
import ICatalog_ItemUI from "../../../../models/ICatalog_ItemUI";
import INotification from "../../../../models/INotification";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwS3DownloadLink from "../../../shared/OwS3DownloadLink/OwS3DownloadLink";
import OwS3Uploader from "../../../shared/OwS3Uploader/OwS3Uploader";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import "./CatalogDetailView.scss";
import { Socket } from "socket.io-client";

type Props = {
    catalogModel: ICatalog;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
};

type State = {};

export default class CatalogDetailView extends Component<Props, State> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {}

    componentWillUnmount(): void {}

    getAttachmentDownloadLink = (catalog: ICatalog) => {
        if (catalog && catalog.PDF) {
            return <OwS3DownloadLink attachment={catalog.PDF} leftIconName={"fad fa-download"} title={"download"} noTopOffset={true} />;
        } else {
            return null;
        }
    };

    render() {
        return (
            <div className={"CatalogDetailView"}>
                <div className={"row"}>
                    <div className={"col"}>
                        <OwLabel title={"pdf_catalog"} noBottomMargin={true} leftIconClass={"fad fa-file-alt"} />
                        <div>
                            <OwS3Uploader
                                socket={this.props.socket}
                                userModel={this.props.userModel!}
                                supplierModel={this.props.supplierModel}
                                isReadOnly={false}
                                resourceType={FileUploadResourceTypeEnum.catalog}
                                catalogGuid={this.props.catalogModel.guid}
                            />
                        </div>

                        <div className={"mt-2 position-relative"}>{this.getAttachmentDownloadLink(this.props.catalogModel)}</div>
                    </div>
                </div>
            </div>
        );
    }
}
